// extracted by mini-css-extract-plugin
export default {"root":"TfLnf_e4mfqH8W695sZ1","active":"RurZLweArzPZAXjsg7ld","placeHolderShimmer":"tyA8tZpwjdDtB0ptguBH"};